/**
 * A boolean operator that can be applied to a group of conditions.
 * 
 * @enum {number}
 */
export const ConditionGroupOperator = {
    /**
     * Indicates that the group evaluates to true only if all of its conditions are true.
     */
    And: 1,

    /**
     * Indicates that the group evaluates to true if any of its conditions is true.
     */
    Or: 2
};
